import { render, staticRenderFns } from "./matchGSPgoods.vue?vue&type=template&id=05a0d02e&scoped=true"
import script from "./matchGSPgoods.vue?vue&type=script&lang=js"
export * from "./matchGSPgoods.vue?vue&type=script&lang=js"
import style0 from "./matchGSPgoods.vue?vue&type=style&index=0&id=05a0d02e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a0d02e",
  null
  
)

export default component.exports